var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31613 12.2069C2.09554 12.2069 1.15963 13.2908 1.33747 14.4983L2.91018 25.1768C3.27154 27.6304 5.37679 29.4483 7.85682 29.4483H18.929C21.3786 29.4483 23.4674 27.6736 23.8633 25.2562L25.6196 14.5301C25.8189 13.3127 24.8795 12.2069 23.6459 12.2069H3.31613Z",
    fill: "#F2B93F",
    stroke: "#6D4B40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1C16.0862 1 18.1889 3.23436 18.2404 6.01173L18.2414 6.11613V17.2139C18.2414 17.3053 18.1727 17.3793 18.0881 17.3793C18.0128 17.3793 17.9502 17.3208 17.9372 17.2436L17.9348 17.2139V6.11613C17.9348 3.47328 15.9493 1.33082 13.5 1.33082C11.0829 1.33082 9.11753 3.41727 9.06622 6.01207L9.0652 6.11613V17.2139C9.0652 17.3053 8.99656 17.3793 8.9119 17.3793C8.83665 17.3793 8.77406 17.3208 8.76108 17.2436L8.75861 17.2139V6.11613C8.75861 3.29057 10.8814 1 13.5 1Z",
    stroke: "#6D4B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodbag);
export default __webpack_public_path__ + "static/media/foodbag.ce8e96618c514ce1c621941970a9dd7e.svg";
export { ForwardRef as ReactComponent };